import { observer } from 'mobx-react-lite';
import React, { useRef } from 'react';

import { Popup, PopupSection, Heading, Button } from '@flixbus/honeycomb-react';

import { rideDetailsStore } from 'pages/RideDetails/RideDetailsStore';

import { AUTOBATCH_POPUP_ARIA, AUTOBATCH_POPUP_TEXT } from './texts';

/**
 * Popup shown once the store's autobatch flow has combined consecutive
 * segments for the same driver. It reads the singleton `rideDetailsStore`
 * for the open flag and calls back into the store to close.
 */
const AutobatchNotificationPopup = observer(() => {
	const targetRef = useRef(null);

	return (
		<Popup
			id={AUTOBATCH_POPUP_ARIA.popupId}
			aria-labelledby={AUTOBATCH_POPUP_ARIA.labelId}
			aria-describedby={AUTOBATCH_POPUP_ARIA.labelId}
			active={rideDetailsStore.showAutobatchPopup}
			onOverlayClick={() => rideDetailsStore.disableAutobatchPopup()}
			targetRef={targetRef}
		>
			<PopupSection type="title">
				<Heading id={AUTOBATCH_POPUP_ARIA.titleId} size={1} sectionHeader flushSpace>
					{AUTOBATCH_POPUP_TEXT.title}
				</Heading>
			</PopupSection>
			<PopupSection type="content">
				<Heading id={AUTOBATCH_POPUP_ARIA.subtitleId} size={2}>
					{AUTOBATCH_POPUP_TEXT.subtitle}
				</Heading>
				<div>
					<img alt={AUTOBATCH_POPUP_TEXT.imageAlt} src={require('./autobatch.png')} />
				</div>
				<div>{AUTOBATCH_POPUP_TEXT.body}</div>
			</PopupSection>

			<PopupSection type="actions">
				<Button appearance="primary" onClick={() => rideDetailsStore.disableAutobatchPopup()}>
					{AUTOBATCH_POPUP_TEXT.buttonLabel}
				</Button>
			</PopupSection>
		</Popup>
	);
});

export default AutobatchNotificationPopup;
